import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify';
import { ClassificationService } from './services/classification-service';
import { ClassificationServiceImpl } from './services/impls/classification-service';
import { FetchClassificationApi } from './apis/fetch-classification-api';
import { FetchClassificationApiImpl } from './apis/impls/fetch-classification-api';

export const classificationModule = new ContainerModule((bind) => {
    bind(ClassificationService).to(ClassificationServiceImpl);
    bind(FetchClassificationApi).to(FetchClassificationApiImpl);
});
